import { Folder } from "scripts/app";
import { ApiError } from "scripts/api/errors";

type FolderDb = {
    id: string;
    name: string;
    created_at: Date;
    updated_at: Date;
}


/**
 * Получение всех папок
 * @returns 
 */
export const apiFetchFolders = async () => {
    try {
        const response = await fetch('/folder/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            console.error(`Ошибка ${response.status}`);
            return null;
        }
        const res = await response.json();
        let folders: FolderDb[] = [];
        res.forEach((element: FolderDb) => {
            folders.push({id: element.id, name: element.name, created_at: element.created_at, updated_at: element.updated_at});
        });

        return folders;
        
    } catch (err) {
        console.error('Запрос не удался', err);
        return null;
    }
}



/**
 * Сохранение папки в базу данных
 */
export const saveFolderToDb = async (folderName: string): Promise<Folder> => {
    const response = await fetch('/folder/', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            name: folderName
        })
    });

    if (!response.ok) {
        // Пробрасываем статус И текст причины от сервера, чтобы в поддержке
        // сразу понять 401: «Not authenticated» (cookie не дошла) vs
        // «поддельная подпись» (ключ сменился) vs «пользователь не найден».
        let detail = "";
        try {
            const body = await response.json();
            detail = typeof body?.detail === "string" ? body.detail : "";
        } catch { /* тело не JSON — не критично */ }
        console.error(`Ошибка создания папки: HTTP ${response.status} ${detail}`);
        throw new ApiError(response.status, detail || undefined);
    }

    return await response.json();
}


/**
 * Удаление папки
 */
export const deleteFolderToDb = async (id: string) => {
    try {
        const response = await fetch(`/folder/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
        });

        if (!response.ok) {
            console.error(`Ошибка ${response.status}`);
            return null;
        }

        
    } catch (err) {
        console.error('Запрос не удался', err);
        return null;
    }
}


